var _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPl9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 322.71 500.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:.45}.a,.b,.c{isolation:isolate}.b{opacity:.6}.c{opacity:.8}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m241.4 0-80.51 143.09H0L80.45 0h161",
    className: "a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.89 143.09h161L241.4 0H80.45Z",
    className: "b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m80.45 286.12 80.44-143L80.45 0 0 143.09Z",
    className: "c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m81.25 500.79 80.51-143.09h161L242.2 500.79H81.25",
    className: "a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.76 357.7H.8l80.45 143.09h161Z",
    className: "b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m242.2 214.67-80.44 143 80.44 143.12 80.51-143.09Z",
    className: "c"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPl9);
export default __webpack_public_path__ + "static/media/pl9.97811583405854a7b75ee478be2152b1.svg";
export { ForwardRef as ReactComponent };